import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'audit', lazy: async () => ({ Component: (await import('./AuditPage')).AuditPage }) },
];
